export const TEMPLATE_INVOICE_IDS = [4, 5];

export const MULTIPLE_LINE_TITLES = ['商品コード', '商品名', '数量', '単価', '金額'];

export const SETTING_TEMPLATE_TYPE = ['user', 'organization'];

export const MULTIPLE_LINE_BUSINESS_TITLES = {'氏名' : '', 'Name' : '', '社名': '', 'Company Name': '', '部署': '', '役職': '', 'メールアドレス': '', '電話番号': '', '携帯電話': '', 'FAX': '', 'URL': '', '郵便番号': '', '住所': ''}